import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractCrudService } from 'src/app/shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';

@Injectable({
  providedIn: 'root',
})
export class FaqService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  getFormIds(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}`);
  }

  getAllResponses(params: { getRelation: boolean; limit: number; page: number; filter: string }): Observable<any[]> {
    const query = `?getRelation=${params.getRelation ? 1 : 0}&limit=${params.limit}&page=${params.page}&filter=${params.filter}`;
    return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}${query}`);
  }

  public findByName(name: string): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byName/${name}`
    );
  }

  getFormResponsesByFormId(formId: string): Observable<any[]> {
    if (!formId || formId.length !== 36) {
      console.error('Erro: ID inválido para busca de respostas.');
      return new Observable<any[]>();
    }

    return this.httpClient.get<any[]>(`${API_PATH}form-responses/${formId}`);
  }

  public findByType(type: number): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byType/${type}`
    );
  }

  findByFilter(filterForm: any, pagination: any): Observable<any[]> {
    const params = {
      getRelation: 0,
      limit: 36,
      page: 0,
      filter: '',
      ...pagination,
    };

    const payload = { ...filterForm, ...params };

    return this.httpClient.post<any[]>(
      `${API_PATH}form-responses/filter`,
      payload
    );
  }

  sendResponseEmail(emailData: {
    email: string;
    question: string;
    response: string;
    responder: string;
    responderType: string;
    date: string
  }): Observable<any> {
    return this.httpClient.post(`${API_PATH}form-responses/sendResponseEmail`, emailData);
  }

}
